var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCiLogoLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 621,
    height: 265,
    viewBox: "0 0 621 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 0.5,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.3772,
    x2: 11.3772,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 22.2544,
    x2: 22.2544,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 33.1316,
    x2: 33.1316,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 44.0088,
    x2: 44.0088,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 54.886,
    x2: 54.886,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 65.7632,
    x2: 65.7632,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 76.6404,
    x2: 76.6404,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 87.5176,
    x2: 87.5176,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 98.3948,
    x2: 98.3948,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 109.272,
    x2: 109.272,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 120.149,
    x2: 120.149,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 131.026,
    x2: 131.026,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 141.904,
    x2: 141.904,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 152.781,
    x2: 152.781,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 163.658,
    x2: 163.658,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 174.535,
    x2: 174.535,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 185.412,
    x2: 185.412,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 196.29,
    x2: 196.29,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 207.167,
    x2: 207.167,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 218.044,
    x2: 218.044,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 228.921,
    x2: 228.921,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 239.798,
    x2: 239.798,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 250.676,
    x2: 250.676,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 261.553,
    x2: 261.553,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 272.43,
    x2: 272.43,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 283.307,
    x2: 283.307,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 294.184,
    x2: 294.184,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 305.062,
    x2: 305.062,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 315.939,
    x2: 315.939,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 326.816,
    x2: 326.816,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 337.693,
    x2: 337.693,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 348.57,
    x2: 348.57,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 359.448,
    x2: 359.448,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 370.325,
    x2: 370.325,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 381.202,
    x2: 381.202,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 392.079,
    x2: 392.079,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 402.956,
    x2: 402.956,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 413.833,
    x2: 413.833,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 424.711,
    x2: 424.711,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 435.588,
    x2: 435.588,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 446.465,
    x2: 446.465,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 457.342,
    x2: 457.342,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 468.219,
    x2: 468.219,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 479.097,
    x2: 479.097,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 489.974,
    x2: 489.974,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 500.851,
    x2: 500.851,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 511.728,
    x2: 511.728,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 522.605,
    x2: 522.605,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 533.483,
    x2: 533.483,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 544.36,
    x2: 544.36,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 555.237,
    x2: 555.237,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 566.114,
    x2: 566.114,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 576.991,
    x2: 576.991,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 587.869,
    x2: 587.869,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 598.746,
    x2: 598.746,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 609.623,
    x2: 609.623,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 620.5,
    x2: 620.5,
    y2: 265,
    stroke: "#F0F0F0"
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 620,
    y2: 0.5,
    stroke: "#F0F0F0"
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    y1: 11.5,
    x2: 620,
    y2: 11.5,
    stroke: "#F0F0F0"
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    y1: 22.5,
    x2: 620,
    y2: 22.5,
    stroke: "#F0F0F0"
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    y1: 33.5,
    x2: 620,
    y2: 33.5,
    stroke: "#F0F0F0"
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    y1: 44.5,
    x2: 620,
    y2: 44.5,
    stroke: "#F0F0F0"
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    y1: 55.5,
    x2: 620,
    y2: 55.5,
    stroke: "#F0F0F0"
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    y1: 66.5,
    x2: 620,
    y2: 66.5,
    stroke: "#F0F0F0"
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    y1: 77.5,
    x2: 620,
    y2: 77.5,
    stroke: "#F0F0F0"
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    y1: 88.5,
    x2: 620,
    y2: 88.5,
    stroke: "#F0F0F0"
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    y1: 99.5,
    x2: 620,
    y2: 99.5,
    stroke: "#F0F0F0"
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    y1: 110.5,
    x2: 620,
    y2: 110.5,
    stroke: "#F0F0F0"
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    y1: 121.5,
    x2: 620,
    y2: 121.5,
    stroke: "#F0F0F0"
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    y1: 132.5,
    x2: 620,
    y2: 132.5,
    stroke: "#F0F0F0"
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    y1: 143.5,
    x2: 620,
    y2: 143.5,
    stroke: "#F0F0F0"
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    y1: 154.5,
    x2: 620,
    y2: 154.5,
    stroke: "#F0F0F0"
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    y1: 165.5,
    x2: 620,
    y2: 165.5,
    stroke: "#F0F0F0"
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    y1: 176.5,
    x2: 620,
    y2: 176.5,
    stroke: "#F0F0F0"
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    y1: 187.5,
    x2: 620,
    y2: 187.5,
    stroke: "#F0F0F0"
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    y1: 198.5,
    x2: 620,
    y2: 198.5,
    stroke: "#F0F0F0"
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    y1: 209.5,
    x2: 620,
    y2: 209.5,
    stroke: "#F0F0F0"
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    y1: 220.5,
    x2: 620,
    y2: 220.5,
    stroke: "#F0F0F0"
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    y1: 231.5,
    x2: 620,
    y2: 231.5,
    stroke: "#F0F0F0"
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    y1: 242.5,
    x2: 620,
    y2: 242.5,
    stroke: "#F0F0F0"
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    y1: 253.5,
    x2: 620,
    y2: 253.5,
    stroke: "#F0F0F0"
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    y1: 264.5,
    x2: 620,
    y2: 264.5,
    stroke: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1094_7686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.018 165.799V182.158H285.394V165.799H269.018ZM279.182 176.406H275.241V171.552H279.182V176.406Z",
    fill: "#F05234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.725 155.007H291.984V182.149H298.725V155.007Z",
    fill: "#F05234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.979 165.799H304.528V171.541H313.239V174.422H304.528V189.303H319.979V183.287H311.161V180.23H319.979V165.799Z",
    fill: "#F3AB1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.704 155.007V182.149H330.498V172.101H333.868V182.149H341.018V155.007H333.868V165.8H330.498V155.007H323.704Z",
    fill: "#F3AB1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.667 155.007V182.149H374.461V172.101H377.831V182.149H384.981V155.007H377.831V165.8H374.461V155.007H367.667Z",
    fill: "#009C7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.22 177.064L361.239 183.069L365.384 178.434L359.064 171.542H364.663V165.8H358.644V160.387H355.22H351.807V165.8H345.788V171.542H351.387L345.066 178.434L349.212 183.069L355.22 177.064Z",
    fill: "#009C7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.187 146C397.837 146 394.305 149.594 394.305 154.021C394.305 158.448 397.837 162.042 402.187 162.042C406.537 162.042 410.068 158.448 410.068 154.021C410.068 149.594 406.537 146 402.187 146ZM402.187 156.048C401.089 156.048 400.195 155.139 400.195 154.021C400.195 152.903 401.089 151.994 402.187 151.994C403.285 151.994 404.179 152.903 404.179 154.021C404.179 155.139 403.285 156.048 402.187 156.048Z",
    fill: "#3771B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.989 171.728V165.34H389.385V171.728H398.817V176.845H394.359V192.142H410.122V176.396H405.46V171.728H415H414.989ZM403.748 186.554H400.625V182.149H403.748V186.554Z",
    fill: "#3771B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.835 91.3605H252.551C252.551 91.3605 253.693 77.5 237.236 77.3067C220.779 77.1134 222.339 89.8419 223.982 92.4097C225.624 94.9775 229.272 96.9378 237.431 100.527C245.59 104.117 254.918 107.927 254.111 118.502C253.303 129.077 243.251 139.044 226.46 137.912C209.669 136.78 205.548 128.303 205.13 120.186H207.831C207.831 120.186 206.077 133.853 222.004 134.571C237.96 135.289 239.492 127.862 239.492 125.322C239.492 121.843 237.932 118.75 226.348 113.615C214.765 108.479 208.221 104.172 208.945 93.4865C209.669 82.8012 220.863 74.6009 236.178 75.015C251.493 75.4292 254.389 83.8504 254.807 91.3329L254.835 91.3605Z",
    fill: "#024383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.776 75.9521H258.871L279.366 136.613H284.963L303.397 103.369L314.257 136.613H319.965L353.714 75.9521H351.319L326.147 120.598L311.667 75.9521H294.068L302.561 100.47L291.172 120.709L276.776 75.9521Z",
    fill: "#024383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.713 75.9521L332.492 136.613H349.562L381.251 78.2162L412.716 136.613H415L382.504 75.9521H365.713Z",
    fill: "#024383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.142 137.527C391.362 137.527 390.555 137.278 389.887 136.726L378.693 127.697C377.857 127.035 377.384 126.013 377.384 124.964V112.953C377.384 110.993 378.971 109.419 380.948 109.419C382.925 109.419 384.512 110.993 384.512 112.953V123.279L394.37 131.259C395.901 132.501 396.124 134.738 394.871 136.229C394.175 137.085 393.145 137.527 392.086 137.527H392.142Z",
    fill: "#F94F29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1094_7686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 117,
    fill: "white",
    transform: "translate(205 75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiLogoLine);
export default __webpack_public_path__ + "static/media/ci-logo-line.f7274e4682252eb767c8f4e576505f9c.svg";
export { ForwardRef as ReactComponent };